import { render, staticRenderFns } from "./icon-configurator-energy-compatibility-3.svg?vue&type=template&id=0cabf805&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports